import React, { useEffect, useState, useRef, lazy, Suspense } from "react";
import { Link } from "react-router-dom";
import CourseModules from "./CourseModules";
import { Tab, Col, Nav, Row, Tabs } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import AdminUser from "../assets/images/admin-user.png";
import CourseService from "../services/course.service";
import AuthService from "../services/auth.service";
import { Form } from "react-bootstrap";

import CheckIcon from "../assets/images/check.png";

import LoadingGif from "../../src/assets/images/Loading.gif";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

import UserService from "../services/user.service";

import Player from "./Player";

import Preview from "./Preview";
import SettingsService from "../services/settings.service";

import CertService from "../services/cert.service";

const ViewCourse = () => {
  const location = useLocation();
  const { cid, isCatalog } = location.state;

  const [validated, setValidated] = useState(false);

  const [loadActivity, setLoadActivity] = useState(false);

  const [certLoading, setCertLoading] = useState(true);

  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  const pdfContainerRef = useRef(null);

  const [compSts, setComSts] = useState({
    act_id: [],
    comp_sts: [],
  });

  const [feedback, setFeedback] = useState({
    queOne: "",
    queTwo: "",
    suggestion: "",
    ratings: "",
  });

  const [learnerFeedback, setLearnerFeedback] = useState({});

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFeedback({ ...feedback, [name]: value });
  };

  const [allCerts, setAllCerts] = useState({});

  const [certTemp, setCertTemp] = useState("");

  const [userId, setUserId] = useState("");

  const [selectedActivityId, setSelectedActivityId] = useState(null);

  const [currentCourse, setCurrentCourse] = useState({
    coursename: "",
    courseimg: "",
    coursedescription: "",
    tempid: "",
    cat_id: "",
  });

  const [currentCourseName, setCurrentCourseName] = useState("");

  const [courseCompSts, setCourseCompSts] = useState("");

  const [courseActivities, setCourseActivities] = useState([]);

  // const [allCoursesActs, setAllCoursesActs] = useState([]);

  const [secondActivityUnlocked, setSecondActivityUnlocked] = useState(false);

  // const [fellowStudents, setFellowStudents] = useState([]);

  const [addedElements, setAddedElements] = useState([]);

  const [currentUser, setCurrentUser] = useState("");

  const [courseName, setCourseName] = useState("");

  const [mergedData, setMergedData] = useState([]);
  const [key, setKey] = useState("0");

  // const [activityResult, setActivityResult] = useState([]);
  const [activitySts, setActivitySts] = useState("");
  const [attempt, setAttempt] = useState("");

  // const [inCompleted, setInCompleted] = useState(true);

  const [attemptCount, setAttemptCount] = useState("");

  const [isCompleted, setIscompleted] = useState({});

  // const [currentActivity, setCurrentActivity] = useState({});
  const [highestScore, setHighestScore] = useState("");

  const stageRef = useRef(null);

  const rectWidth = 100;
  const rectHeight = 100;

  const canvasRef = useRef(null);

  const getCourseCompSts = (bccid, csid) => {
    CourseService.getLearnersCoursesByCsid(bccid, csid)
      .then((resp) => {
        setCourseCompSts(resp.data[0].comp_sts);
      })
      .catch((e) => console.log(e));
  };

  const getCurrentCourse = (user, cid) => {
    CourseService.getCourseById(user, cid)
      .then((resp) => {
        setCurrentCourse({
          coursename: resp.data.course_info[0].name,
          courseimg: resp.data.course_info[0].course_image,
          coursedescription: resp.data.course_info[0].description,
          tempid: resp.data.course_info[0].templete,
          cat_id: resp.data.course_info[0].category_id,
        });

        setCourseName(resp.data.course_info[0].name);
      })
      .catch((e) => console.log(e));
  };

  const getCertificateTemp = (tempid) => {
    const user = AuthService.getCurrentUser();

    SettingsService.getTempByID(tempid, user.user)
      .then((resp) => {
        setCertTemp(resp.data[0].filepath);
      })
      .catch((e) => console.log(e));

    const certdata = {
      uid: user.user,
      cid: cid,
    };

    CertService.getCertBycond(certdata)
      .then((resp) => {
        setAllCerts(resp.data[0]);
        setCertLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setCertLoading(true);
      });
  };

  const getCourseActivities = () => {
    const user = AuthService.getCurrentUser();

    const actressdata = {
      course_id: cid,
      stdid: user.user,
    };

    CourseService.getAllActRes(actressdata)
      .then((resp) => {
        if (resp.data.error !== "data not found") {
          setCourseActivities(resp.data);
          setLoadActivity(true);
        }
      })
      .catch((e) => console.log(e));
  };

  const cerImgSrc = "https://lmsaero.aeonsoftware.net/cit/" + certTemp;

  const stageWidth = 800;
  const stageHeight = 600;

  const imageX = (stageWidth - 650) / 2;
  const imageY = (stageHeight - 500) / 2;

  const fetchActivityResults = (data, datanew) => {
    CourseService.fetchActivityResultCondition(datanew)
      .then((resp) => {
        setActivitySts(resp.data[0].res_sts);
        setHighestScore(resp.data[0].stdscor);
      })
      .catch((e) => console.log(e));

    CourseService.fetchActivityResult(data)
      .then((res) => {
        const actRes = res.data;
        setAttemptCount(actRes.length);
        // const maxScoreData = actRes.reduce(
        //   (max, current) => (current.score > max.score ? current : max),
        //   actRes[0]
        // );

        // setActivityResult(maxScoreData);
        // setActivitySts(maxScoreData.res_sts);
        // setHighestScore(maxScoreData.score);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    setUserId(user.user);

    getFeedbackData();

    UserService.getProfileById(user.user)
      .then((res) => {
        setCurrentUser(res.data.first_name + " " + res.data.last_name);
      })
      .catch((e) => console.log(e));

    CertService.getCertEleByCorsId(cid)
      .then((resp) => {
        setAddedElements(resp.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, [selectedActivityId]);

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    const data = {
      course_id: cid,
      activity_id: key,
      student_id: user.user,
    };

    const datanew = {
      corsid: cid,
      acrto: key,
      baps: user.user,
    };

    if (user) {
      fetchActivityResults(data, datanew);
    }
  }, []);

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (cid && user) {
      getCourseCompSts(user.user, cid);
    }
  }, []);

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (cid && user) {
      getCurrentCourse(user.user, cid);
    }
  }, []);

  useEffect(() => {
    getCourseActivities();
  }, []);

  useEffect(() => {
    const user = AuthService.getCurrentUser();
  }, []);

  const fetchActivityRes = (act_id) => {
    const user = AuthService.getCurrentUser();

    const actData = {
      corsid: cid,
      actid: act_id,
      usp: user.user,
    };

    if (actData) {
      CourseService.getCourseActivityById(actData)
        .then((resp) => {
          setAttempt(resp.data[0].attemptsCount);
        })
        .catch((e) => console.log(e));
    }

    const resdata = {
      course_id: cid,
      activity_id: act_id,
      student_id: user.user,
    };

    const datanew = {
      corsid: cid,
      acrto: act_id,
      baps: user.user,
    };

    if (user) {
      fetchActivityResults(resdata, datanew);
    }
  };

  const getFeedbackData = () => {
    const user = AuthService.getCurrentUser();

    const feedbackData = {
      usp: user.user,
      corsid: cid,
    };

    CourseService.getAllFeedbacks(feedbackData)
      .then((resp) => {
        setLearnerFeedback(resp.data[0]);
        setRating(resp.data[0].review);
        setFeedback({
          queOne: resp.data[0].course_feedback,
          queTwo: resp.data[0].course_element_feedback,
          suggestion: resp.data[0].suggestions,
          ratings: resp.data[0].review,
        });
      })
      .catch((e) => console.log(e));
  };

  // const { text, isListening, listen, voiceSupported } = useVoice();

  const submitFeedback = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      // setError(true);
      // setErrMessage("* Please fill all required fields!");

      // setTimeout(() => {
      //   setError(false);
      // }, 2000);
      return;
    }

    const user = AuthService.getCurrentUser();

    const datas = {
      usp: user.user,
      corsid: cid,
      feedbk: feedback.queOne,
      efeedbk: feedback.queTwo,
      suggest: feedback.suggestion,
      reviw: rating,
    };

    CourseService.givFeedback(datas)
      .then((resp) => {
        toast.success("Feedback Submitted Successfully!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });

        getFeedbackData();
      })
      .catch((e) => console.log(e));
  };

  const { transcript: transcriptOne, resetTranscript: resetTranscriptOne } =
    useSpeechRecognition();
  const { transcript: transcriptTwo, resetTranscript: resetTranscriptTwo } =
    useSpeechRecognition();
  const { transcript: transcriptThree, resetTranscript: resetTranscriptThree } =
    useSpeechRecognition();

  const [isListeningOne, setIsListeningOne] = useState(false);
  const [isListeningTwo, setIsListeningTwo] = useState(false);
  const [isListeningThree, setIsListeningThree] = useState(false);
  const microphoneRef = useRef(null);
  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    return (
      <div className="mircophone-container">
        Browser is not Support Speech Recognition.
      </div>
    );
  }
  const handleListening = (e, inputType) => {
    e.preventDefault();
    if (inputType === "queOne") {
      setIsListeningOne(true);
      setIsListeningTwo(false);
      setIsListeningThree(false);
    } else if (inputType === "queTwo") {
      setIsListeningOne(false);
      setIsListeningTwo(true);
      setIsListeningThree(false);
    } else if (inputType === "suggestion") {
      setIsListeningOne(false);
      setIsListeningTwo(false);
      setIsListeningThree(true);
    }

    // microphoneRef.current.classList.add("listening");
    SpeechRecognition.startListening({
      continuous: true,
    });
  };

  const stopHandle = (e, inputType) => {
    e.preventDefault();
    if (inputType === "queOne") {
      setIsListeningOne(false);
      resetTranscriptOne(); // Reset transcript for queOne
      setFeedback({ ...feedback, queOne: transcriptOne });
    } else if (inputType === "queTwo") {
      setIsListeningTwo(false);
      resetTranscriptTwo(); // Reset transcript for queTwo
      setFeedback({ ...feedback, queTwo: transcriptTwo });
    } else if (inputType == "suggestion") {
      setIsListeningThree(false);
      resetTranscriptThree(); // Reset transcript for queTwo
      setFeedback({ ...feedback, suggestion: transcriptThree });
    }
    // microphoneRef.current.classList.remove("listening");
    SpeechRecognition.stopListening();
  };

  const handleReset = (e) => {
    e.preventDefault();
    stopHandle();
    resetTranscriptOne();
    resetTranscriptTwo();
    resetTranscriptThree();
  };

  return (
    <>
      <div className="container-fluid learner">
        <ToastContainer />
        <Tab.Container id="left-tabs-example" defaultActiveKey={key}>
          <Row>
            <Col xl={3} lg={3} md={12} sm={12}>
              <div className="outer-box">
                <div className="action-flex">
                  <Link to={isCatalog ? "/Catalog" : "/Learn"}>
                    <div className="action-item">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 19.379 19.382"
                        >
                          <g
                            id="left-arrow-in-circular-button-black-symbol"
                            transform="translate(-0.6 511.567)"
                          >
                            <path
                              id="Path_13057"
                              data-name="Path 13057"
                              d="M9.381-511.546A9.911,9.911,0,0,0,4.162-509.4a11.83,11.83,0,0,0-1.457,1.468,10.165,10.165,0,0,0-1.878,3.88A8.145,8.145,0,0,0,.6-501.873a8.145,8.145,0,0,0,.228,2.181,10.088,10.088,0,0,0,1.931,3.945,11.828,11.828,0,0,0,1.468,1.457,10.164,10.164,0,0,0,3.88,1.878,8.146,8.146,0,0,0,2.181.228,8.146,8.146,0,0,0,2.181-.228,10.541,10.541,0,0,0,3.141-1.339A9.712,9.712,0,0,0,19-497.606a9.626,9.626,0,0,0,.914-2.94,12.941,12.941,0,0,0,0-2.655,9.626,9.626,0,0,0-.914-2.94,9.19,9.19,0,0,0-1.889-2.625,9.01,9.01,0,0,0-2.553-1.813,9.581,9.581,0,0,0-2.9-.91A14.607,14.607,0,0,0,9.381-511.546Zm1.1,5.618a.61.61,0,0,1,.25.766c-.03.068-.622.69-1.328,1.392L8.126-502.5l3.315.019c3.277.019,3.319.019,3.421.1a.536.536,0,0,1,.262.508.536.536,0,0,1-.262.508c-.1.08-.144.08-3.421.1l-3.315.019L9.4-499.977c.706.7,1.3,1.324,1.328,1.392a.607.607,0,0,1-.77.808c-.14-.053-3.683-3.588-3.751-3.744a1.386,1.386,0,0,1-.015-.683c.053-.133,3.581-3.679,3.736-3.751A.637.637,0,0,1,10.477-505.928Z"
                              transform="translate(0 0)"
                            />
                          </g>
                        </svg>
                      </span>
                      <span>Back</span>
                    </div>
                  </Link>
                </div>
                <div className="course-info">
                  <div className="course-name">
                    <span>{currentCourse.coursename}</span>
                  </div>
                  <div className="course-modules">
                    <label htmlFor="">Course Modules</label>
                    <Nav variant="pills" className="flex-column">
                      <Nav.Item>
                        <Nav.Link eventKey="0">
                          <div className="topics-list">
                            <div className="topics">
                              <div className="topic-info">
                                <div className="topic-content">
                                  <span className="name">Course Overview</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Nav.Link>
                      </Nav.Item>

                      <div className="topics-list">
                        {Array.isArray(courseActivities)
                          ? courseActivities.map((courseActivity, index) => {
                              return (
                                <Nav.Item
                                  key={index}
                                  className={
                                    courseActivity &&
                                    courseActivity.position !== "1" &&
                                    courseActivities[index - 1] &&
                                    courseActivities[index - 1].comp !== "1"
                                      ? "disabled"
                                      : ""
                                  }
                                >
                                  <Nav.Link
                                    eventKey={courseActivity.id}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setKey(courseActivity.id);
                                      setSelectedActivityId(courseActivity.id);
                                      fetchActivityRes(courseActivity.id);
                                    }}
                                    // disabled={!res_sts}

                                    disabled={
                                      courseActivity &&
                                      courseActivity.position !== "1" &&
                                      courseActivities[index - 1] &&
                                      courseActivities[index - 1].comp !== "1"
                                        ? "disabled"
                                        : ""
                                    }
                                  >
                                    <div
                                      className="topics"
                                      key={courseActivity.id}
                                    >
                                      <div className="topic-info">
                                        <div className="icon">
                                          {/* <span>{index}</span> */}
                                          <span>
                                            {courseActivity.file_name.includes(
                                              ".mp4"
                                            ) ? (
                                              <>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="30.889"
                                                  height="26.391"
                                                  viewBox="0 0 30.889 26.391"
                                                >
                                                  <g
                                                    id="youtube"
                                                    transform="translate(0 0)"
                                                  >
                                                    <path
                                                      id="Subtraction_8"
                                                      data-name="Subtraction 8"
                                                      d="M12.382,26.391c-8.785,0-8.811-.012-9.463-.335L2.813,26A5.1,5.1,0,0,1,.344,23.243l-.027-.072C0,22.334,0,22.334,0,14.087v-1.8C0,4.065,0,4.065.313,3.217l.025-.069A4.794,4.794,0,0,1,3.591.109C3.956.022,5.5.008,15.408,0h3.736c6.766,0,7.76.02,8.122.1A4.86,4.86,0,0,1,30.809,4.1c.084.475.09,1.348.072,9.334l0,1.592c-.013,7.485-.013,7.485-.3,8.181-.019.046-.04.1-.062.15a5.148,5.148,0,0,1-2.487,2.694l-.09.04c-.662.294-.688.306-10.079.306H12.382ZM12.738,7.11a.88.88,0,0,0-.789.532c-.12.257-.12.356-.12,5.55s0,5.293.12,5.55a.883.883,0,0,0,.792.532.741.741,0,0,0,.373-.1c.1-.055,1.541-1.056,3.862-2.68,3.322-2.33,3.676-2.594,3.784-2.83a1.052,1.052,0,0,0,0-.947c-.108-.235-.462-.5-3.784-2.83-2.321-1.624-3.765-2.626-3.862-2.68A.754.754,0,0,0,12.738,7.11Z"
                                                      transform="translate(0 0)"
                                                    />
                                                  </g>
                                                </svg>
                                              </>
                                            ) : courseActivity.file_name.includes(
                                                ".pdf"
                                              ) ? (
                                              <>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="22.365"
                                                  height="26.83"
                                                  viewBox="0 0 22.365 26.83"
                                                >
                                                  <g
                                                    id="pdf-file"
                                                    transform="translate(0)"
                                                  >
                                                    <path
                                                      id="Path_13703"
                                                      data-name="Path 13703"
                                                      d="M86.962-468.88a3.083,3.083,0,0,0-.621.271,3.448,3.448,0,0,0-1.014,1.058c-.333.63-.327.3-.327,11.969s-.007,11.339.327,11.975a3.613,3.613,0,0,0,1.072,1.09c.66.372.163.359,9.92.34l8.92-.019.379-.145a3.28,3.28,0,0,0,1.373-1.2c.379-.668.373-.447.373-9.3v-8.126l-4.166-4.013L99.027-469l-5.853.006C87.766-468.994,87.3-468.987,86.962-468.88Zm14.158,5.928,3.466,3.339h-7.03v-3.339c0-1.839.02-3.339.052-3.339S99.217-464.792,101.12-462.953Zm-9.234,10.173a1.51,1.51,0,0,1,1.288,1.55,1.457,1.457,0,0,1-.49,1.235,2.308,2.308,0,0,1-1.74.586h-.517v1.89H89.185l.013-2.633.02-2.627.262-.038A10.785,10.785,0,0,1,91.886-452.779Zm5,0a2.433,2.433,0,0,1,1.694,1.147,2.984,2.984,0,0,1-.163,3.03c-.536.794-1.5,1.14-3.126,1.146-.471,0-.955-.019-1.066-.038l-.2-.044V-452.8l.281-.025A13.914,13.914,0,0,1,96.889-452.779Zm6.278.422.02.491h-2.165v1.26h2.027v.945h-2.027v2.142H99.779v-5.354l1.687.013,1.681.019Z"
                                                      transform="translate(-85 469)"
                                                    />
                                                    <path
                                                      id="Path_13704"
                                                      data-name="Path 13704"
                                                      d="M168.118-198.921c-.1.025-.118.12-.118.8v.775l.19.038a1.743,1.743,0,0,0,.87-.12.79.79,0,0,0,.275-1.216A1.322,1.322,0,0,0,168.118-198.921Z"
                                                      transform="translate(-162.572 215.973)"
                                                    />
                                                    <path
                                                      id="Path_13705"
                                                      data-name="Path 13705"
                                                      d="M242.249-198.518l-.248.025v3.534l.575-.025a1.576,1.576,0,0,0,1.674-1.209,3.938,3.938,0,0,0-.026-1.335A1.766,1.766,0,0,0,242.249-198.518Z"
                                                      transform="translate(-231.733 215.571)"
                                                    />
                                                  </g>
                                                </svg>
                                              </>
                                            ) : (
                                              <>
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="35"
                                                  height="30"
                                                  viewBox="0 0 54.269 43.126"
                                                >
                                                  <g
                                                    id="Group_11456"
                                                    data-name="Group 11456"
                                                    transform="translate(-372.554 -403.874)"
                                                  >
                                                    <path
                                                      id="Subtraction_10"
                                                      data-name="Subtraction 10"
                                                      d="M3329.57,5900c-3.291,0-6.615,0-9.881-.006h-19.938a6.905,6.905,0,0,1-7.112-5.823,7.178,7.178,0,0,1-.084-1.235v-28.985a7.092,7.092,0,0,1,1.6-4.618,6.95,6.95,0,0,1,4.215-2.367,8.287,8.287,0,0,1,1.227-.093l.2,0h10.854a6.908,6.908,0,0,1,6.637,4.238c.969,2.016,1.727,3.671,2.387,5.208a3.48,3.48,0,0,0,3.544,2.279h.022c2.953-.007,6.029-.011,9.974-.011h11.325c1.648,0,2.291.64,2.291,2.283v21.944a6.879,6.879,0,0,1-5.261,6.967,9.087,9.087,0,0,1-1.934.208h-.174C3336.186,5900,3332.861,5900,3329.57,5900Zm-19.243-15.02a3.965,3.965,0,0,0-2.865,1.143,4.065,4.065,0,0,0-.022,5.688,4.149,4.149,0,0,0,6.012-.353l-1.1-1.133a2.54,2.54,0,0,1-2.067,1,2.154,2.154,0,0,1-1.574-.648,2.34,2.34,0,0,1-.648-1.722,2.215,2.215,0,0,1,.687-1.7,2.372,2.372,0,0,1,1.656-.632,2.511,2.511,0,0,1,2.024,1.011l1.067-1.209A4.079,4.079,0,0,0,3310.327,5884.98Zm-10.119,5.345h0l-1.023,1.254a4.739,4.739,0,0,0,3.289,1.353,3.1,3.1,0,0,0,2.04-.644,2.081,2.081,0,0,0,.776-1.677,2,2,0,0,0-.605-1.573,3.935,3.935,0,0,0-1.7-.809,5.54,5.54,0,0,1-1.4-.468.611.611,0,0,1-.3-.533.657.657,0,0,1,.247-.539,1.036,1.036,0,0,1,.677-.2,3.394,3.394,0,0,1,2.067.758l.869-1.254a4.121,4.121,0,0,0-1.342-.748,4.747,4.747,0,0,0-1.54-.264,3.18,3.18,0,0,0-1.964.594,2,2,0,0,0-.786,1.688,1.968,1.968,0,0,0,.62,1.606,4.966,4.966,0,0,0,1.963.831,3.787,3.787,0,0,1,1.134.412.684.684,0,0,1,.016,1.1,1.216,1.216,0,0,1-.743.2A3.647,3.647,0,0,1,3300.208,5890.326Zm17.918-5.345a3.966,3.966,0,0,0-2.871,1.139,4.025,4.025,0,0,0,0,5.665,4.189,4.189,0,0,0,5.742,0,4.022,4.022,0,0,0,0-5.665A3.966,3.966,0,0,0,3318.126,5884.98Zm20.371,3.029h0v4.834h1.716v-7.687H3337.9l-1.99,4.225-1.98-4.225h-2.322v7.688h1.716v-4.839l2.069,4.2h1.023Zm-14.882-2.853v7.688h1.716v-2.451h1.189l1.7,2.452h2.111l-1.947-2.75a2.271,2.271,0,0,0,1.463-2.387,2.348,2.348,0,0,0-.764-1.947,4.2,4.2,0,0,0-2.557-.6Zm-22.551-17.237v8.764a.225.225,0,0,0,.173.255c2.016.752,4.126,1.542,6.274,2.348l1.017.379V5870.9a.223.223,0,0,0-.173-.253l-5.93-2.221-.329-.123Zm15.91,0-.42.158c-.784.295-1.618.608-2.426.907l-2.129.807-.173.061-.462.173c-.539.2-1.116.419-1.689.629a.2.2,0,0,0-.157.231v8.782l7.457-2.8v-8.951Zm-7.948-3.955a.357.357,0,0,0-.116.02c-2.678,1-5.362,2.007-7.667,2.873a.857.857,0,0,0-.09.037l-.005,0-.063.028.044.019.011.005.005,0a.707.707,0,0,0,.066.026c2.31.868,4.76,1.786,7.71,2.889a.293.293,0,0,0,.1.017.286.286,0,0,0,.1-.017c.822-.3,1.656-.617,2.464-.921l.069-.026.183-.069a.747.747,0,0,0,.083-.039l.011-.005.043-.022,2.137-.788c.565-.216,1.142-.432,1.7-.642l.092-.034.428-.161.362-.136.27-.1-.073-.031-.007,0c-.048-.021-.085-.037-.123-.05-2.834-1.065-5.328-2-7.623-2.855A.355.355,0,0,0,3309.026,5863.964Zm9.106,27.462a2.12,2.12,0,0,1-1.623-.721,2.658,2.658,0,0,1,0-3.5,2.178,2.178,0,0,1,3.246,0,2.658,2.658,0,0,1,0,3.5A2.12,2.12,0,0,1,3318.132,5891.426Zm8.453-2.519h-1.254v-2.277h1.287a2.119,2.119,0,0,1,1.155.231.977.977,0,0,1,.33.853,1.166,1.166,0,0,1-.318.908A1.858,1.858,0,0,1,3326.585,5888.907Z"
                                                      transform="translate(-2920 -5453)"
                                                    />
                                                    <path
                                                      id="Path_13693"
                                                      data-name="Path 13693"
                                                      d="M1068.11,261.36h19.926a6.9,6.9,0,0,1,6.885,5.228c.054.2.079.416.133.7a13.384,13.384,0,0,0-4.558-.33q-9.464-.03-18.929,0a1.235,1.235,0,0,1-1.329-.876c-.567-1.362-1.214-2.687-1.827-4.033C1068.314,261.852,1068.229,261.638,1068.11,261.36Z"
                                                      transform="translate(-668.322 146.086)"
                                                    />
                                                  </g>
                                                </svg>
                                              </>
                                            )}
                                          </span>
                                        </div>
                                        <div className="topic-content">
                                          <div className="topic-name">
                                            <span className="name">
                                              {courseActivity.activity_name}
                                            </span>
                                            {courseActivity.file_name.includes(
                                              ".mp4"
                                            ) ? (
                                              <>
                                                <span className="type">
                                                  Video
                                                </span>
                                              </>
                                            ) : courseActivity.file_name.includes(
                                                ".pdf"
                                              ) ? (
                                              <>
                                                <span className="type">
                                                  PDF
                                                </span>
                                              </>
                                            ) : courseActivity.file_name.includes(
                                                ".doc"
                                              ) ? (
                                              <>
                                                <span className="type">
                                                  Doc
                                                </span>
                                              </>
                                            ) : (
                                              <>
                                                <span className="type">
                                                  SCORM
                                                </span>
                                              </>
                                            )}

                                            {courseActivity &&
                                            courseActivity.position !== "1" &&
                                            courseActivities[index - 1] &&
                                            courseActivities[index - 1].comp !==
                                              "1" ? (
                                              <span className="unlock">
                                                <svg
                                                  xmlns="http://www.w3.org/2000/svg"
                                                  width="12px"
                                                  height="12px"
                                                  enable-background="new 0 0 24 24"
                                                  viewBox="0 0 24 24"
                                                  id="lock"
                                                >
                                                  <path
                                                    d="M17,9V7c0-2.8-2.2-5-5-5S7,4.2,7,7v2c-1.7,0-3,1.3-3,3v7c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3v-7C20,10.3,18.7,9,17,9z M9,7
 c0-1.7,1.3-3,3-3s3,1.3,3,3v2H9V7z M13.1,15.5c0,0-0.1,0.1-0.1,0.1V17c0,0.6-0.4,1-1,1s-1-0.4-1-1v-1.4c-0.6-0.6-0.7-1.5-0.1-2.1
 c0.6-0.6,1.5-0.7,2.1-0.1C13.6,13.9,13.7,14.9,13.1,15.5z"
                                                  ></path>
                                                </svg>
                                                Unlock by completing previous
                                                module!
                                              </span>
                                            ) : (
                                              <></>
                                            )}
                                          </div>
                                          <div className="topic-result">
                                            <span>
                                              {courseActivity.comp === "1" ? (
                                                <>
                                                  <img
                                                    src={CheckIcon}
                                                    width={20}
                                                    alt=""
                                                  />
                                                </>
                                              ) : (
                                                ""
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Nav.Link>
                                </Nav.Item>
                              );
                            })
                          : null}

                        {loadActivity ? (
                          <>
                            {currentCourse.cat_id !== "9" ? (
                              <>
                                <Nav.Item
                                  className={
                                    courseCompSts !== "1" ? "disabled" : ""
                                  }
                                  onClick={() => {
                                    getCertificateTemp(currentCourse.tempid);
                                  }}
                                >
                                  <Nav.Link
                                    eventKey="cc"
                                    disabled={courseCompSts !== "1"}
                                  >
                                    <div className="topics">
                                      <div className="topic-info flex-center">
                                        <div className="icon">
                                          <span>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="29.363"
                                              height="28.813"
                                              viewBox="0 0 29.363 28.813"
                                            >
                                              <g
                                                id="certificate-_1_"
                                                transform="translate(-0.987 506.954)"
                                              >
                                                <path
                                                  id="Path_13731"
                                                  data-name="Path 13731"
                                                  d="M2-506.865a1.376,1.376,0,0,0-.547.357c-.507.507-.466-.351-.466,9.943,0,10.115-.029,9.39.386,9.874a1.86,1.86,0,0,0,.5.38l.294.138H9.41l-.035-.2a3.3,3.3,0,0,0-.4-.748,3.68,3.68,0,0,1-.415-.72l-.04-.179h-1.8a7.393,7.393,0,0,1-1.854-.075,1.064,1.064,0,0,1-.1-.38,1.684,1.684,0,0,0-1.5-1.474,1.159,1.159,0,0,1-.357-.1c-.058-.046-.075-1.416-.075-6.488,0-3.535.023-6.46.052-6.5a1,1,0,0,1,.4-.161,1.714,1.714,0,0,0,1.48-1.451.944.944,0,0,1,.121-.391c.069-.069,1.566-.081,10.783-.081,9.649,0,10.708.012,10.789.092a.382.382,0,0,1,.092.247,1.59,1.59,0,0,0,.512,1.105,1.59,1.59,0,0,0,1.105.512c.363,0,.34-.455.34,6.615,0,5.084-.017,6.454-.069,6.5a1.211,1.211,0,0,1-.363.1,1.684,1.684,0,0,0-1.5,1.474,1.064,1.064,0,0,1-.1.38,7.393,7.393,0,0,1-1.854.075h-1.8l-.04.179a3.512,3.512,0,0,1-.415.725,3.3,3.3,0,0,0-.4.743l-.035.2h7.243l.294-.138a1.86,1.86,0,0,0,.5-.38c.415-.484.386.236.386-9.845,0-10.271.035-9.471-.461-9.96s.829-.461-14.243-.455C3.97-506.951,2.248-506.939,2-506.865Z"
                                                  transform="translate(0 0)"
                                                />
                                                <path
                                                  id="Path_13732"
                                                  data-name="Path 13732"
                                                  d="M44.957-463.931a3.044,3.044,0,0,1-.455.961,2.8,2.8,0,0,1-1.174.777l-.328.1v12.01l.265.063a2.182,2.182,0,0,1,1.008.564,2.59,2.59,0,0,1,.662,1.146l.035.2h3.207l.1-.184a4.939,4.939,0,0,1,.311-.478c.374-.5.374-.5.374-1.474v-.9l.178-.219a2.1,2.1,0,0,1,.754-.512,5.182,5.182,0,0,0,.708-.4,3.8,3.8,0,0,0,.409-.685c.484-.99.645-1.082,1.865-1.059l.806.017.472-.334c.558-.391.794-.5,1.111-.5s.553.109,1.111.5l.472.334.806-.017c1.215-.023,1.376.069,1.842,1.025a5.422,5.422,0,0,0,.391.685,2.716,2.716,0,0,0,.61.357c.616.288.841.455,1,.76.109.225.115.3.081,1.008-.04.852-.029.892.368,1.422a4.939,4.939,0,0,1,.311.478l.1.184h3.207l.035-.2a2.59,2.59,0,0,1,.662-1.146,2.182,2.182,0,0,1,1.008-.564l.265-.063-.012-5.993-.017-5.993-.23-.069a2.427,2.427,0,0,1-1.67-1.681l-.04-.184h-10.3C47.059-464,44.957-463.983,44.957-463.931Zm19.333,1.808a.306.306,0,0,1,.017.484c-.075.04-3,.058-9.045.058s-8.97-.017-9.045-.058a.306.306,0,0,1,.017-.484c.115-.081,1.065-.092,9.027-.092S64.175-462.2,64.29-462.123Zm.035,2.458a.3.3,0,0,1-.081.484c-.115.058-1.992.075-8.981.075s-8.866-.017-8.981-.075a.3.3,0,0,1-.081-.484C46.351-459.774,64.175-459.774,64.325-459.665Zm-.035,2.435a.306.306,0,0,1,.017.484c-.075.04-3,.058-9.045.058s-8.97-.017-9.045-.058a.306.306,0,0,1,.017-.484c.115-.081,1.065-.092,9.027-.092S64.175-457.31,64.29-457.23Z"
                                                  transform="translate(-39.594 -40.481)"
                                                />
                                                <path
                                                  id="Path_13733"
                                                  data-name="Path 13733"
                                                  d="M148.217-293.747a2.021,2.021,0,0,1-1.767.558c-.674-.012-.852,0-.967.075a2.429,2.429,0,0,0-.415.679,3.4,3.4,0,0,1-.461.76,5.2,5.2,0,0,1-.8.489,1.918,1.918,0,0,0-.685.461,2.092,2.092,0,0,0-.04.812,5.361,5.361,0,0,1,0,.881,3.373,3.373,0,0,1-.415.76,3.322,3.322,0,0,0-.4.708c-.04.184.063.415.38.841a1.745,1.745,0,0,1,.443,1.577c-.046,1.013-.058,1,.794,1.416.754.368.818.432,1.209,1.255a2.612,2.612,0,0,0,.409.656c.115.075.259.081.9.046a1.833,1.833,0,0,1,1.67.472c.409.288.507.334.731.334s.322-.046.731-.334a1.833,1.833,0,0,1,1.67-.472c.645.035.789.029.9-.046a2.612,2.612,0,0,0,.409-.656c.391-.823.455-.887,1.209-1.255.852-.415.841-.4.794-1.416a1.759,1.759,0,0,1,.449-1.589c.305-.409.42-.668.38-.835a5.331,5.331,0,0,0-.409-.7,3.376,3.376,0,0,1-.415-.766,5.291,5.291,0,0,1,0-.875,2.092,2.092,0,0,0-.04-.812,1.918,1.918,0,0,0-.685-.461,4.923,4.923,0,0,1-.8-.489,3.541,3.541,0,0,1-.461-.76c-.368-.783-.386-.794-1.267-.743a3.775,3.775,0,0,1-.915-.023,4.693,4.693,0,0,1-.783-.432C148.868-294.1,148.741-294.115,148.217-293.747Zm1.324,2.539a3.757,3.757,0,0,1,3.046,3.512,3.779,3.779,0,0,1-2.073,3.616,3.53,3.53,0,0,1-1.71.4,3.719,3.719,0,0,1-3.4-2.113,3.577,3.577,0,0,1-.386-1.9,3.5,3.5,0,0,1,1.128-2.493A3.732,3.732,0,0,1,149.542-291.208Z"
                                                  transform="translate(-133.136 -200.688)"
                                                />
                                                <path
                                                  id="Path_13734"
                                                  data-name="Path 13734"
                                                  d="M203.137-235.664a3.177,3.177,0,0,0-2.343,3.005,3.008,3.008,0,0,0,.823,2.217,3.18,3.18,0,0,0,1.3.875,3.208,3.208,0,0,0,3.926-1.624,3.06,3.06,0,0,0,.305-1.462,3.169,3.169,0,0,0-2.113-2.942A3.8,3.8,0,0,0,203.137-235.664Z"
                                                  transform="translate(-188.304 -255.586)"
                                                />
                                                <path
                                                  id="Path_13735"
                                                  data-name="Path 13735"
                                                  d="M160.7-80.91c-.046.1-.386.887-.754,1.739s-.662,1.554-.651,1.566a3.422,3.422,0,0,0,.587-.184c.426-.15.6-.19.691-.15a1.64,1.64,0,0,1,.34.581,4.156,4.156,0,0,0,.259.553,14.514,14.514,0,0,0,.714-1.514L162.7-80.2l.15-.34-.518.04c-.7.052-.99-.023-1.313-.351l-.242-.253Z"
                                                  transform="translate(-149.193 -401.337)"
                                                />
                                                <path
                                                  id="Path_13736"
                                                  data-name="Path 13736"
                                                  d="M292.719-79.648c-.305.322-.616.4-1.307.345l-.512-.04.138.311c.075.173.443,1.013.818,1.877a14.742,14.742,0,0,0,.725,1.543,4.157,4.157,0,0,0,.259-.553,1.553,1.553,0,0,1,.34-.581c.086-.04.271,0,.691.15a3.879,3.879,0,0,0,.593.178c.017-.012-1.382-3.241-1.474-3.4C292.961-79.867,292.88-79.815,292.719-79.648Z"
                                                  transform="translate(-273.222 -402.529)"
                                                />
                                              </g>
                                            </svg>
                                          </span>
                                        </div>
                                        <div className="topic-content">
                                          <div className="topic-name g-10">
                                            <span className="name">
                                              Completion Certificate
                                            </span>
                                            {courseCompSts !== "1" ? (
                                              <>
                                                <span className="unlock">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="12px"
                                                    height="12px"
                                                    enableBackground="new 0 0 24 24"
                                                    viewBox="0 0 24 24"
                                                    id="lock"
                                                  >
                                                    <path
                                                      d="M17,9V7c0-2.8-2.2-5-5-5S7,4.2,7,7v2c-1.7,0-3,1.3-3,3v7c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3v-7C20,10.3,18.7,9,17,9z M9,7
	                                                                                                    c0-1.7,1.3-3,3-3s3,1.3,3,3v2H9V7z M13.1,15.5c0,0-0.1,0.1-0.1,0.1V17c0,0.6-0.4,1-1,1s-1-0.4-1-1v-1.4c-0.6-0.6-0.7-1.5-0.1-2.1
	                                                                                                    c0.6-0.6,1.5-0.7,2.1-0.1C13.6,13.9,13.7,14.9,13.1,15.5z"
                                                    ></path>
                                                  </svg>
                                                  <span>
                                                    Unlock by completing all
                                                    module!
                                                  </span>
                                                </span>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Nav.Link>
                                </Nav.Item>
                              </>
                            ) : (
                              <></>
                            )}

                            <Nav.Item
                              className={
                                courseCompSts !== "1" ? "disabled" : ""
                              }
                            >
                              <Nav.Link
                                eventKey="fb"
                                disabled={courseCompSts !== "1"}
                                title="Give Feedback"
                              >
                                <div className="topics">
                                  <div className="topic-info flex-center">
                                    <div className="icon">
                                      <span>
                                        <svg
                                          version="1.0"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="30px"
                                          height="30px"
                                          viewBox="0 0 512.000000 512.000000"
                                          preserveAspectRatio="xMidYMid meet"
                                        >
                                          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                                            <path
                                              d="M4675 4972 c-52 -35 -1584 -1576 -1595 -1605 -5 -16 -10 -94 -10
-175 0 -234 18 -252 252 -252 81 0 159 5 175 10 32 12 1586 1560 1609 1602 18
34 18 72 0 106 -8 15 -82 94 -164 176 -140 139 -152 148 -193 153 -32 3 -52
-1 -74 -15z"
                                            />
                                            <path
                                              d="M533 4469 c-226 -38 -418 -202 -501 -431 l-27 -73 0 -1270 0 -1270
23 -75 c54 -175 183 -321 349 -397 126 -58 107 -56 786 -60 l627 -4 0 -325 c0
-353 2 -371 55 -412 20 -16 42 -22 76 -22 47 0 52 4 555 380 l508 380 622 0
c391 0 651 4 700 11 210 29 387 153 484 339 74 143 70 62 70 1450 l0 1245
-597 -596 c-522 -520 -605 -599 -653 -620 -53 -23 -64 -24 -285 -24 l-230 0
-60 29 c-76 38 -143 105 -181 181 l-29 60 0 235 0 235 32 60 c26 49 116 144
487 515 251 250 456 458 456 462 0 11 -3203 8 -3267 -3z m1733 -801 c43 -47
47 -106 11 -159 -41 -61 -32 -60 -761 -57 -630 3 -662 4 -689 22 -78 53 -74
167 6 217 31 19 51 19 715 17 l684 -3 34 -37z m-26 -744 c56 -34 77 -112 45
-174 -32 -62 -8 -60 -750 -60 -750 0 -714 -3 -751 65 -32 60 -1 150 61 175 11
5 323 9 693 9 607 1 677 -1 702 -15z m1797 -774 c41 -25 56 -54 55 -107 0 -50
-29 -95 -69 -112 -21 -8 -438 -11 -1605 -9 l-1578 3 -31 31 c-58 58 -48 155
19 197 25 15 146 16 1602 17 1542 0 1576 0 1607 -20z"
                                            />
                                          </g>
                                        </svg>
                                      </span>
                                    </div>
                                    <div className="topic-content">
                                      <div className="topic-name g-10">
                                        <span className="name">Feedback</span>
                                        {courseCompSts !== "1" ? (
                                          <>
                                            <span className="unlock">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="12px"
                                                height="12px"
                                                enableBackground="new 0 0 24 24"
                                                viewBox="0 0 24 24"
                                                id="lock"
                                              >
                                                <path
                                                  d="M17,9V7c0-2.8-2.2-5-5-5S7,4.2,7,7v2c-1.7,0-3,1.3-3,3v7c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3v-7C20,10.3,18.7,9,17,9z M9,7
	                                                                                                    c0-1.7,1.3-3,3-3s3,1.3,3,3v2H9V7z M13.1,15.5c0,0-0.1,0.1-0.1,0.1V17c0,0.6-0.4,1-1,1s-1-0.4-1-1v-1.4c-0.6-0.6-0.7-1.5-0.1-2.1
	                                                                                                    c0.6-0.6,1.5-0.7,2.1-0.1C13.6,13.9,13.7,14.9,13.1,15.5z"
                                                ></path>
                                              </svg>
                                              <span>
                                                Unlock by completing all module!
                                              </span>
                                            </span>
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Nav.Link>
                            </Nav.Item>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Nav>
                  </div>
                </div>
              </div>
            </Col>
            <Col xl={9} lg={9} md={12} sm={9}>
              <Tab.Content>
                <Tab.Pane eventKey="0">
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 mb-3">
                      <div className="outer-box f-height">
                        <div className="course-overview">
                          <div className="course-img">
                            {currentCourse.courseimg ? (
                              <>
                                <img
                                  src={
                                    "https://lmsaero.aeonsoftware.net/cit/" +
                                    currentCourse.courseimg
                                  }
                                  alt=""
                                />
                              </>
                            ) : (
                              <>
                                <div className="loadinggif-flex">
                                  <img
                                    src={LoadingGif}
                                    className="loadinggif"
                                    alt=""
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12 col-xl-12 mbr-3">
                      <div className="outer-box">
                        <div className="cflex">
                          <div className="heading">
                            <h1>Course Overview</h1>
                          </div>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: currentCourse.coursedescription,
                          }}
                          className="course-overview"
                        />
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                {Array.isArray(courseActivities)
                  ? courseActivities.map((courseActivity) => (
                      <Tab.Pane
                        key={courseActivity.id}
                        eventKey={courseActivity.id}
                      >
                        <div className="row">
                          <div className="col-xl-12 col-lg-12 mb-3">
                            <div className="outer-box">
                              <div className="course-overview player">
                                <div className="course-img">
                                  <Player
                                    aid={selectedActivityId}
                                    cid={cid}
                                    getCourseActivities={getCourseActivities}
                                    getCourseCompSts={getCourseCompSts}
                                    attemptCount={attemptCount}
                                    attempt={attempt}
                                    fetchActivityResults={fetchActivityResults}
                                    file_name={courseActivity.file_name}
                                    activity_type={courseActivity.activity_type}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-8 col-xl-8 mbr-3">
                            <div className="outer-box">
                              <div className="cflex">
                                <div className="heading">
                                  <h1>{courseActivity.activity_name}</h1>
                                </div>
                              </div>
                              <div className="inner-box-flex">
                                <div className="inner-box left">
                                  <div className="row">
                                    <div className="col-xl-4">
                                      <div className="card">
                                        <div className="card-body">
                                          <h5 className="card-title">
                                            Completion
                                          </h5>
                                          <h1>
                                            {courseActivity.comp === "1"
                                              ? activitySts
                                              : "Not Started"}
                                          </h1>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-xl-4">
                                      <div className="card">
                                        <div className="card-body">
                                          <h5 className="card-title">Score</h5>
                                          <h1>
                                            {courseActivity.comp === "1" &&
                                            highestScore >= 0
                                              ? highestScore
                                              : "0"}
                                            %
                                          </h1>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-xl-4">
                                      <div className="card">
                                        <div className="card-body">
                                          <h5 className="card-title">
                                            Attempts
                                          </h5>
                                          <h1>
                                            {attemptCount >= 0
                                              ? attemptCount
                                              : "0"}
                                            /
                                            {attempt === "0"
                                              ? "Unlimitted"
                                              : attempt}
                                          </h1>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {attempt !== "0" &&
                                  attemptCount >= attempt ? (
                                    <>
                                      <p>
                                        You have reached the maximum number of
                                        attempts.
                                      </p>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab.Pane>
                    ))
                  : null}

                <Tab.Pane eventKey="cc">
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 mb-3">
                      <div className="outer-box">
                        <div className="course-overview">
                          <div className="cert-img">
                            <div className="cflex">
                              <div className="heading">
                                <h1>Completion Certificate</h1>
                              </div>
                            </div>
                            <div className="certificate-preview mb-3">
                              <Preview
                                cerImgSrc={cerImgSrc}
                                stageWidth={stageWidth}
                                stageHeight={stageHeight}
                                addedElements={addedElements}
                                currentUser={currentUser}
                                courseName={courseName}
                                allCerts={allCerts}
                                cid={cid}
                                userId={userId}
                                certLoading={certLoading}
                                catid={currentCourse.cat_id}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-12 col-xl-12 mbr-3">
                      <div className="outer-box">
                        <div className="cflex">
                          <div className="heading">
                            <h1>Course Overview</h1>
                          </div>
                        </div>
                        <p>{currentCourse.description}</p>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="fb">
                  <div className="row">
                    <div className="col-xl-12 col-lg-12">
                      <div className="outer-box">
                        <div className="course-overview">
                          <div className="course-img">
                            <div className="cflex">
                              <div className="heading">
                                <h1>Feedback</h1>
                              </div>
                            </div>
                            <div className="inner-box">
                              <Form>
                                <div className="add-user-form feedback-form">
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Form.Label>
                                      How well did you achieve this learning
                                      goal in this course?
                                    </Form.Label>
                                    <div className="input-box">
                                      <Form.Control
                                        type="email"
                                        placeholder="Type Here"
                                        name="queOne"
                                        value={feedback.queOne}
                                        onChange={(e) =>
                                          setFeedback({
                                            ...feedback,
                                            queOne: e.target.value,
                                          })
                                        }
                                      />

                                      <span className="icon voice-icon">
                                        {isListeningOne ? (
                                          <button
                                            onClick={(e) =>
                                              stopHandle(e, "queOne")
                                            }
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              id="Layer_1"
                                              data-name="Layer 1"
                                              viewBox="0 0 24 24"
                                              width="24"
                                              height="24"
                                            >
                                              <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm0,21c-4.962,0-9-4.038-9-9S7.038,3,12,3s9,4.038,9,9-4.038,9-9,9Zm4-11v4c0,1.105-.895,2-2,2h-4c-1.105,0-2-.895-2-2v-4c0-1.105.895-2,2-2h4c1.105,0,2,.895,2,2Z" />
                                            </svg>
                                          </button>
                                        ) : (
                                          <>
                                            <button
                                              ref={microphoneRef}
                                              onClick={(e) =>
                                                handleListening(e, "queOne")
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                id="Layer_1"
                                                data-name="Layer 1"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                              >
                                                <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-2,7c0-1.105.895-2,2-2s2,.895,2,2v5c0,1.105-.895,2-2,2s-2-.895-2-2v-5Zm3,10.916v2.084h-2v-2.084c-2.834-.477-5-2.948-5-5.916h2c0,2.206,1.794,4,4,4s4-1.794,4-4h2c0,2.968-2.166,5.439-5,5.916Z" />
                                              </svg>
                                            </button>
                                          </>
                                        )}
                                      </span>
                                    </div>
                                  </Form.Group>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicEmail"
                                  >
                                    <Form.Label>
                                      How useful to you was this course element?{" "}
                                    </Form.Label>
                                    <div className="input-box">
                                      <Form.Control
                                        type="text"
                                        placeholder="Type Here"
                                        name="queTwo"
                                        value={feedback.queTwo}
                                        onChange={(e) =>
                                          setFeedback({
                                            ...feedback,
                                            queTwo: e.target.value,
                                          })
                                        }
                                      />
                                      <span className="icon voice-icon">
                                        {isListeningTwo ? (
                                          <button
                                            onClick={(e) =>
                                              stopHandle(e, "queTwo")
                                            }
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              id="Layer_1"
                                              data-name="Layer 1"
                                              viewBox="0 0 24 24"
                                              width="24"
                                              height="24"
                                            >
                                              <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm0,21c-4.962,0-9-4.038-9-9S7.038,3,12,3s9,4.038,9,9-4.038,9-9,9Zm4-11v4c0,1.105-.895,2-2,2h-4c-1.105,0-2-.895-2-2v-4c0-1.105.895-2,2-2h4c1.105,0,2,.895,2,2Z" />
                                            </svg>
                                          </button>
                                        ) : (
                                          <>
                                            <button
                                              ref={microphoneRef}
                                              onClick={(e) =>
                                                handleListening(e, "queTwo")
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                id="Layer_1"
                                                data-name="Layer 1"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                              >
                                                <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-2,7c0-1.105.895-2,2-2s2,.895,2,2v5c0,1.105-.895,2-2,2s-2-.895-2-2v-5Zm3,10.916v2.084h-2v-2.084c-2.834-.477-5-2.948-5-5.916h2c0,2.206,1.794,4,4,4s4-1.794,4-4h2c0,2.968-2.166,5.439-5,5.916Z" />
                                              </svg>
                                            </button>
                                          </>
                                        )}
                                      </span>
                                    </div>
                                  </Form.Group>
                                  <Form.Group
                                    className="mb-3"
                                    controlId="formBasicDesignation"
                                  >
                                    <Form.Label>
                                      Do you have any suggestions?
                                    </Form.Label>
                                    <div className="input-box">
                                      <textarea
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        name="suggestion"
                                        value={feedback.suggestion}
                                        onChange={(e) =>
                                          setFeedback({
                                            ...feedback,
                                            suggestion: e.target.value,
                                          })
                                        }
                                      ></textarea>
                                      <span className="icon voice-icon">
                                        {isListeningThree ? (
                                          <button
                                            onClick={(e) =>
                                              stopHandle(e, "suggestion")
                                            }
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              id="Layer_1"
                                              data-name="Layer 1"
                                              viewBox="0 0 24 24"
                                              width="24"
                                              height="24"
                                            >
                                              <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm0,21c-4.962,0-9-4.038-9-9S7.038,3,12,3s9,4.038,9,9-4.038,9-9,9Zm4-11v4c0,1.105-.895,2-2,2h-4c-1.105,0-2-.895-2-2v-4c0-1.105.895-2,2-2h4c1.105,0,2,.895,2,2Z" />
                                            </svg>
                                          </button>
                                        ) : (
                                          <>
                                            <button
                                              ref={microphoneRef}
                                              onClick={(e) =>
                                                handleListening(e, "suggestion")
                                              }
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                id="Layer_1"
                                                data-name="Layer 1"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                              >
                                                <path d="m12,0C5.383,0,0,5.383,0,12s5.383,12,12,12,12-5.383,12-12S18.617,0,12,0Zm-2,7c0-1.105.895-2,2-2s2,.895,2,2v5c0,1.105-.895,2-2,2s-2-.895-2-2v-5Zm3,10.916v2.084h-2v-2.084c-2.834-.477-5-2.948-5-5.916h2c0,2.206,1.794,4,4,4s4-1.794,4-4h2c0,2.968-2.166,5.439-5,5.916Z" />
                                              </svg>
                                            </button>
                                          </>
                                        )}
                                      </span>
                                    </div>
                                  </Form.Group>

                                  <div className="star-rating">
                                    {[...Array(5)].map((star, index) => {
                                      index += 1;
                                      return (
                                        <button
                                          type="button"
                                          key={index}
                                          className={
                                            index <= (hover || rating)
                                              ? "on"
                                              : "off"
                                          }
                                          onClick={() => setRating(index)}
                                          onMouseEnter={() => setHover(index)}
                                          onMouseLeave={() => setHover(rating)}
                                        >
                                          <span className="star">&#9733;</span>
                                        </button>
                                      );
                                    })}
                                  </div>
                                </div>
                                <div className="act-btn">
                                  <button
                                    onClick={handleReset}
                                    className="reset-btn"
                                  >
                                    Reset
                                  </button>
                                  <button onClick={submitFeedback}>
                                    Submit
                                  </button>
                                </div>
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-12 col-xl-12 mbr-3">
                      <div className="outer-box">
                        <div className="cflex">
                          <div className="heading">
                            <h1>Course Overview</h1>
                          </div>
                        </div>
                        <p>{currentCourse.description}</p>
                      </div>
                    </div>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </>
  );
};

export default ViewCourse;
